import {
  type ICustomMapping,
  CustomMappingType,
} from '@principle-theorem/practice-migrations/interfaces';
import { CustomMapping } from '../../../custom-mapping';
import { IBaseMigrationItemCode } from '../../../interfaces';
import { ItemCodesMappingHandler } from '../../../mappings/item-codes';
import {
  ADAItemSourceEntity,
  IPracticeWorksItemCode,
  PracticeWorksADAItem,
} from '../../source/entities/ada-item';

export const ITEM_CODE_LINE_ITEM_MAPPING_TYPE = 'itemCodeLineItemMapping';

export const ITEM_CODE_LINE_ITEM_MAPPING: ICustomMapping = CustomMapping.init({
  metadata: {
    label: 'Item Codes to Line Items',
    description: ``,
    type: ITEM_CODE_LINE_ITEM_MAPPING_TYPE,
  },
  type: CustomMappingType.SelectionList,
  labelOverrides: {
    sourceIdentifier: 'Id',
    sourceLabel: 'Non-ADA Code',
    destinationIdentifier: 'Map To',
    associatedValue: 'Service Code/Treatment',
  },
});

export class PracticeWorksItemCodeMappingHandler extends ItemCodesMappingHandler<
  PracticeWorksADAItem,
  ADAItemSourceEntity
> {
  override sourceEntity = new ADAItemSourceEntity();
  override customMapping = ITEM_CODE_LINE_ITEM_MAPPING;
  override translateFn = (
    record: IPracticeWorksItemCode
  ): IBaseMigrationItemCode => ({
    id: record.itemCode,
    itemCode: record.itemCode,
    description: `${record.displayCode ?? ''} ${record.description}`,
  });
}
